// src/app/redux/sagas/paramCongesSaga.js
import { all, call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

import {
    setParamCongesLoading,

    fetchParamCongesSuccess,
    fetchParamCongesFail,

    createAbsenceTypeSuccess,
    createAbsenceTypeFail,

    updateAbsenceTypeSuccess,
    updateAbsenceTypeFail,

    deleteAbsenceTypeSuccess,
    deleteAbsenceTypeFail,

    createAcqRuleSuccess,
    createAcqRuleFail,

    deleteAcqRuleSuccess,
    deleteAcqRuleFail,

    createJustifRuleSuccess,
    createJustifRuleFail,

    deleteJustifRuleSuccess,
    deleteJustifRuleFail, updateAcqRuleFail, updateAcqRuleSuccess, updateJustifRuleFail, updateJustifRuleSuccess,
} from "../actions/paramCongesActions";

function getToken() {
    return (
        sessionStorage.getItem("token") ||
        localStorage.getItem("token") ||
        localStorage.getItem("jwt") ||

        ""
    );
}

const extractErrorMessage = (error, fallback) => {
    let msg = fallback;

    if (error?.response?.data?.message) msg = error.response.data.message;
    else if (error?.response?.data?.error) msg = error.response.data.error;
    else if (error?.message) msg = error.message;

    return msg;
};

// ===================== FETCH ALL =====================
export function* fetchParamCongesSaga() {
    const token = sessionStorage.getItem('token');
    const urlTypes = `${API_BASE_URL}/api/paramconges/types`;
    const urlAcq = `${API_BASE_URL}/api/paramconges/acquisitions`;
    const urlJustif = `${API_BASE_URL}/api/paramconges/justificatifs`;

    yield put(setParamCongesLoading(true));

    try {
        console.group("🔵 FETCH_PARAM_CONGES_REQUEST");
        console.log("🌐 URL Types:", urlTypes);
        console.log("🌐 URL Acquisitions:", urlAcq);
        console.log("🌐 URL Justificatifs:", urlJustif);
        console.groupEnd();

        const [typesResp, acqResp, justifResp] = yield all([
            call(getRequest, { url: urlTypes, token }),
            call(getRequest, { url: urlAcq, token }),
            call(getRequest, { url: urlJustif, token }),
        ]);

        const payload = {
            typesAbsences: typesResp.data || [],
            reglesAcquisition: acqResp.data || [],
            justificatifs: justifResp.data || [],
        };

        console.group("✅ FETCH_PARAM_CONGES_SUCCESS");
        console.log("📥 Types:", payload.typesAbsences.length);
        console.log("📥 Acquisitions:", payload.reglesAcquisition.length);
        console.log("📥 Justificatifs:", payload.justificatifs.length);
        console.groupEnd();

        yield put(fetchParamCongesSuccess(payload));
        yield put(setParamCongesLoading(false));
    } catch (error) {
        console.group("❌ FETCH_PARAM_CONGES_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        yield put(fetchParamCongesFail(error.message));
        yield put(setParamCongesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: "Erreur chargement paramètres congés",
            timer: 2000,
            showConfirmButton: false,
        });
    }
}

// ===================== TYPES =====================
export function* createAbsenceTypeSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/paramconges/types`;
    const data = action.payload;

    yield put(setParamCongesLoading(true));

    try {
        console.group("🔵 CREATE_ABSENCE_TYPE_REQUEST");
        console.log("📊 Données:", data);
        console.groupEnd();

        const resp = yield call(postRequest, { url, data, token });

        console.group("✅ CREATE_ABSENCE_TYPE_SUCCESS");
        console.log("📥 Type créé:", resp.data);
        console.groupEnd();

        yield put(createAbsenceTypeSuccess(resp.data));
        yield put(setParamCongesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Type d'absence ajouté",
            timer: 1600,
            showConfirmButton: false,
        });
    } catch (error) {
        console.group("❌ CREATE_ABSENCE_TYPE_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        yield put(createAbsenceTypeFail(error.message));
        yield put(setParamCongesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: "Erreur lors de l'ajout",
            timer: 2000,
            showConfirmButton: false,
        });
    }
}

export function* updateAbsenceTypeSaga(action) {
    const token = sessionStorage.getItem("token");
    const { id, payload } = action.payload;
    const data = action.payload.payload;

    const url = `${API_BASE_URL}/api/paramconges/types/${id}`;
    yield put(setParamCongesLoading(true));

    try {
        console.group("🔵 UPDATE_ABSENCE_TYPE_REQUEST");
        console.log("🆔 ID:", id);
        console.log("📦 Payload:", payload);
        console.groupEnd();

        const resp = yield call(putRequest, { url, data, token });

        console.group("✅ UPDATE_ABSENCE_TYPE_SUCCESS");
        console.log("✅ Updated:", resp.data);
        console.groupEnd();

        yield put(updateAbsenceTypeSuccess(resp.data));
        yield put(setParamCongesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Succès",
            text: "Type mis à jour",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (error) {
        console.group("❌ UPDATE_ABSENCE_TYPE_FAIL");
        console.error("🚨 Erreur complète:", error);
        console.error("🚨 Response data:", error.response?.data);
        console.error("🚨 Response status:", error.response?.status);
        console.groupEnd();

        const errorMessage = extractErrorMessage(error, "Erreur lors de la mise à jour");
        yield put(updateAbsenceTypeFail(errorMessage));
        yield put(setParamCongesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: errorMessage,
            confirmButtonText: "OK",
            confirmButtonColor: "#d33",
        });
    }
}

export function* deleteAbsenceTypeSaga(action) {
    const token = sessionStorage.getItem('token');
    const id = action.payload;
    const url = `${API_BASE_URL}/api/paramconges/types/${id}`;

    yield put(setParamCongesLoading(true));

    try {
        console.group("🔵 DELETE_ABSENCE_TYPE_REQUEST");
        console.log("🆔 ID:", id);
        console.groupEnd();

        yield call(deleteRequest, { url, token });

        console.group("✅ DELETE_ABSENCE_TYPE_SUCCESS");
        console.log("🗑️ Supprimé:", id);
        console.groupEnd();

        yield put(deleteAbsenceTypeSuccess(id));
        yield put(setParamCongesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Type supprimé",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (error) {
        console.group("❌ DELETE_ABSENCE_TYPE_FAIL");
        console.error("🚨 Erreur complète:", error);
        console.error("🚨 Response data:", error.response?.data);
        console.error("🚨 Response status:", error.response?.status);
        console.groupEnd();

        yield put(setParamCongesLoading(false));

        // ✅ Extraire le message d'erreur (même logique que job)
        let errorMessage = "Erreur lors de la suppression";

        if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (error.response?.data?.error) {
            errorMessage = error.response.data.error;
        } else if (error.message) {
            errorMessage = error.message;
        }

        yield put(deleteAbsenceTypeFail(errorMessage));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur de suppression",
            text: errorMessage,
            confirmButtonText: "OK",
            confirmButtonColor: "#d33",
        });
    }

}

// ===================== ACQUISITION =====================
export function* createAcqRuleSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/paramconges/acquisitions`;
    const data = action.payload;

    yield put(setParamCongesLoading(true));

    try {
        console.group("🔵 CREATE_ACQ_RULE_REQUEST");
        console.log("📊 Données:", data);
        console.groupEnd();

        const resp = yield call(postRequest, { url, data, token });

        console.group("✅ CREATE_ACQ_RULE_SUCCESS");
        console.log("📥 Règle créée:", resp.data);
        console.groupEnd();

        yield put(createAcqRuleSuccess(resp.data));
        yield put(setParamCongesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Règle d'acquisition ajoutée",
            timer: 1600,
            showConfirmButton: false,
        });
    } catch (error) {
        console.group("❌ CREATE_ACQ_RULE_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        yield put(createAcqRuleFail(error.message));
        yield put(setParamCongesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: "Erreur ajout règle",
            timer: 2000,
            showConfirmButton: false,
        });
    }
}
export function* updateAcqRuleSaga(action) {
    const token = sessionStorage.getItem("token");
    const { id, payload } = action.payload;
    const data = action.payload.payload;

    const url = `${API_BASE_URL}/api/paramconges/acquisition/${id}`;
    yield put(setParamCongesLoading(true));

    try {
        console.group("🔵 UPDATE_ACQ_RULE_REQUEST");
        console.log("🆔 ID:", id);
        console.log("📦 Payload:", payload);
        console.groupEnd();

        const resp = yield call(putRequest, { url, data, token });

        console.group("✅ UPDATE_ACQ_RULE_SUCCESS");
        console.log("✅ Updated:", resp.data);
        console.groupEnd();

        yield put(updateAcqRuleSuccess(resp.data));
        yield put(setParamCongesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Succès",
            text: "Règle d'acquisition mise à jour",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (error) {
        console.group("❌ UPDATE_ACQ_RULE_FAIL");
        console.error("🚨 Erreur complète:", error);
        console.error("🚨 Response data:", error.response?.data);
        console.error("🚨 Response status:", error.response?.status);
        console.groupEnd();

        const errorMessage = extractErrorMessage(error, "Erreur lors de la mise à jour");
        yield put(updateAcqRuleFail(errorMessage));
        yield put(setParamCongesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: errorMessage,
            confirmButtonText: "OK",
            confirmButtonColor: "#d33",
        });
    }
}

export function* deleteAcqRuleSaga(action) {
    const token = sessionStorage.getItem('token');
    const id = action.payload;
    const url = `${API_BASE_URL}/api/paramconges/acquisitions/${id}`;

    yield put(setParamCongesLoading(true));

    try {
        console.group("🔵 DELETE_ACQ_RULE_REQUEST");
        console.log("🆔 ID:", id);
        console.groupEnd();

        yield call(deleteRequest, { url, token });

        console.group("✅ DELETE_ACQ_RULE_SUCCESS");
        console.log("🗑️ Supprimé:", id);
        console.groupEnd();

        yield put(deleteAcqRuleSuccess(id));
        yield put(setParamCongesLoading(false));
    } catch (error) {
        console.group("❌ DELETE_ABSENCE_TYPE_FAIL");
        console.error("🚨 Erreur complète:", error);
        console.error("🚨 Response data:", error.response?.data);
        console.error("🚨 Response status:", error.response?.status);
        console.groupEnd();

        yield put(setParamCongesLoading(false));

        // ✅ Extraire le message d'erreur (même logique que job)
        let errorMessage = "Erreur lors de la suppression";

        if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (error.response?.data?.error) {
            errorMessage = error.response.data.error;
        } else if (error.message) {
            errorMessage = error.message;
        }

        yield put(deleteAcqRuleFail(errorMessage));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur de suppression",
            text: errorMessage,
            confirmButtonText: "OK",
            confirmButtonColor: "#d33",
        });
    }

}

// ===================== JUSTIFICATIFS =====================
export function* createJustifRuleSaga(action) {
    const token = sessionStorage.getItem('token');
    const url = `${API_BASE_URL}/api/paramconges/justificatifs`;
    const data = action.payload;

    yield put(setParamCongesLoading(true));

    try {
        console.group("🔵 CREATE_JUSTIF_RULE_REQUEST");
        console.log("📊 Données:", data);
        console.groupEnd();

        const resp = yield call(postRequest, { url, data, token });

        console.group("✅ CREATE_JUSTIF_RULE_SUCCESS");
        console.log("📥 Règle créée:", resp.data);
        console.groupEnd();

        yield put(createJustifRuleSuccess(resp.data));
        yield put(setParamCongesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Règle justificatif ajoutée",
            timer: 1600,
            showConfirmButton: false,
        });
    } catch (error) {
        console.group("❌ CREATE_JUSTIF_RULE_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        yield put(createJustifRuleFail(error.message));
        yield put(setParamCongesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: "Erreur ajout justificatif",
            timer: 2000,
            showConfirmButton: false,
        });
    }
}
export function* updateJustifRuleSaga(action) {
    const token = sessionStorage.getItem("token");
    const { id, payload } = action.payload;
    const data = action.payload.payload;

    const url = `${API_BASE_URL}/api/paramconges/justificatifs/${id}`;
    yield put(setParamCongesLoading(true));

    try {
        console.group("🔵 UPDATE_JUSTIF_RULE_REQUEST");
        console.log("🆔 ID:", id);
        console.log("📦 Payload:", payload);
        console.groupEnd();

        const resp = yield call(putRequest, { url, data, token });

        console.group("✅ UPDATE_JUSTIF_RULE_SUCCESS");
        console.log("✅ Updated:", resp.data);
        console.groupEnd();

        yield put(updateJustifRuleSuccess(resp.data));
        yield put(setParamCongesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Succès",
            text: "Justificatif mis à jour",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (error) {
        console.group("❌ UPDATE_JUSTIF_RULE_FAIL");
        console.error("🚨 Erreur complète:", error);
        console.error("🚨 Response data:", error.response?.data);
        console.error("🚨 Response status:", error.response?.status);
        console.groupEnd();

        const errorMessage = extractErrorMessage(error, "Erreur lors de la mise à jour");
        yield put(updateJustifRuleFail(errorMessage));
        yield put(setParamCongesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: errorMessage,
            confirmButtonText: "OK",
            confirmButtonColor: "#d33",
        });
    }
}

export function* deleteJustifRuleSaga(action) {
    const token = sessionStorage.getItem('token');
    const id = action.payload;
    const url = `${API_BASE_URL}/api/paramconges/justificatifs/${id}`;

    yield put(setParamCongesLoading(true));

    try {
        console.group("🔵 DELETE_JUSTIF_RULE_REQUEST");
        console.log("🆔 ID:", id);
        console.groupEnd();

        yield call(deleteRequest, { url, token });

        console.group("✅ DELETE_JUSTIF_RULE_SUCCESS");
        console.log("🗑️ Supprimé:", id);
        console.groupEnd();

        yield put(deleteJustifRuleSuccess(id));
        yield put(setParamCongesLoading(false));
    } catch (error) {
        console.group("❌ DELETE_ABSENCE_TYPE_FAIL");
        console.error("🚨 Erreur complète:", error);
        console.error("🚨 Response data:", error.response?.data);
        console.error("🚨 Response status:", error.response?.status);
        console.groupEnd();

        yield put(setParamCongesLoading(false));

        // ✅ Extraire le message d'erreur (même logique que job)
        let errorMessage = "Erreur lors de la suppression";

        if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (error.response?.data?.error) {
            errorMessage = error.response.data.error;
        } else if (error.message) {
            errorMessage = error.message;
        }

        yield put(deleteJustifRuleFail(errorMessage));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur de suppression",
            text: errorMessage,
            confirmButtonText: "OK",
            confirmButtonColor: "#d33",
        });
    }

}

